import { render, staticRenderFns } from "./CustomerGuarantor.vue?vue&type=template&id=4cd4c088&scoped=true&"
import script from "./CustomerGuarantor.vue?vue&type=script&lang=js&"
export * from "./CustomerGuarantor.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGuarantor.vue?vue&type=style&index=0&id=4cd4c088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4c088",
  null
  
)

export default component.exports